import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { Fragment, Suspense, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.scss';
import translations from './locale/i18n';
import { AppRoutes } from './routes/routes';
import theme, { hcfTheme } from './theme';

import { LicenseInfo } from '@mui/x-license-pro';
import { applyHcfTheme, applyLtsTheme } from './assets/themeVars';
import { CompanyDisplayName, updateFavicon } from './utils';
import { IconCycleLoader } from './components/loaders/IconCycleLoader';

const licenseKey =
  '047afffdc3a894308f4b4a7a6fc885d2Tz0xMTg5NzQsRT0xNzg5MjU3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';

LicenseInfo.setLicenseKey(licenseKey);

const App = () => {
  const [currentTheme, setCurrentTheme] = useState(theme);

  useEffect(() => {
    translations.setup();
    const getCurrentCompany = localStorage.getItem('selectedCompany');
    if (getCurrentCompany === CompanyDisplayName.LewisTreeServiceInc) {
      setCurrentTheme(theme);
      applyLtsTheme();
    } else {
      setCurrentTheme(hcfTheme);
      applyHcfTheme();
    }
    updateFavicon();
  }, []);

  // test: MUI licence key log
  console.log('MUI_X_LICENSE_KEY:', process.env.REACT_APP_MUI_X_LICENSE_KEY);

  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={currentTheme}>
          <CssBaseline />
          <Suspense fallback={<IconCycleLoader />}>
            <Fragment>
              <main>
                <AppRoutes />
              </main>
            </Fragment>
          </Suspense>
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
};

export default App;
